/** @jsxImportSource @emotion/react */

import { FunctionComponent } from 'react'
import { useController } from 'react-hook-form'
import { TextEditor, TextEditorProps } from '../text-editor/TextEditor'
import { ControlledFieldProps } from './types'

type ControlledTextEditorProps = Omit<TextEditorProps, 'onChange' | 'value' | 'errorMessage'> & ControlledFieldProps<string> & {}

const ControlledTextEditor: FunctionComponent<React.PropsWithChildren<ControlledTextEditorProps>> = ({
    name,
    infoMessage,
    label,
    placeholder,
    style,
    defaultValue,
    labelTooltip,
    dataTestId,
    control,
    disabled,
}) => {
    const {
        field: { onChange, value },
        fieldState: { error },
    } = useController({
        name,
        control,
        defaultValue,
    })

    return (
        <TextEditor
            name={name}
            onChange={onChange}
            value={value}
            errorMessage={error?.message}
            errorTooltipMessage={error?.types?.tooltip as string}
            infoMessage={infoMessage}
            label={label}
            placeholder={placeholder}
            style={style}
            labelTooltip={labelTooltip}
            dataTestId={dataTestId}
            disabled={disabled}
        />
    )
}

export { ControlledTextEditor }
